import React from "react";
import TopBar from "@/components/layout/TopBar";
import Footer from "@/components/layout/Footer";
import { PRIVACY_POLICY_SECTIONS, PRIVACY_POLICY_LAST_UPDATED } from "@/data/legalContent";

export default function Privacy() {
  return (
    <div className="min-h-screen relative overflow-x-hidden">
      <div className="relative z-10">
        <TopBar />

        <section className="max-w-[1400px] mx-auto px-6 lg:px-8 py-20 md:py-28">
          <div className="max-w-3xl fade-up">
            <p className="font-display tracking-[0.4em] text-[#19e6c8] text-sm">LEGAL</p>
            <h1 className="brand-title text-4xl sm:text-5xl mt-4 leading-tight">
              Privacy Policy
            </h1>
            <p className="text-white/50 mt-4 text-sm">
              Last updated {PRIVACY_POLICY_LAST_UPDATED} &middot; DRIVN FREIGHT PTY LTD (ABN 41 658 624 385)
            </p>
          </div>

          <div className="max-w-3xl mt-14 space-y-10" data-testid="privacy-page-content">
            {PRIVACY_POLICY_SECTIONS.map((s) => (
              <div key={s.heading}>
                <h2 className="brand-title text-xl text-white/90">{s.heading}</h2>
                <p className="text-white/65 text-[15px] leading-relaxed mt-3 whitespace-pre-line">
                  {s.body}
                </p>
              </div>
            ))}
          </div>
        </section>

        <Footer />
      </div>
    </div>
  );
}
